
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const ButtonComponent = (props) => {
  const { t } = useTranslation();
  const { name,color } = props;
  return (
    <div style={{width: '100%', marginTop: 10, marginBottom: 10}}>
      <Button
        className={name}
        style={{
          backgroundColor: color,
          contrastText: "#fff",
          textTransform: "none"
        }}
        variant="contained"
        onClick={(e) => props.manageArray(e)}
      >
        {t(name)}
      </Button>
    </div>
  );
};

export default ButtonComponent;
